var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('nuxt-link',{staticClass:"floating-icon-wrapper",attrs:{"to":"/gold-points/gacha"}},[_c('img',{attrs:{"src":"/images/icons/floating-gacha-icon.svg","alt":"floating-icon"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }